module.exports = __webpack_public_path__ + "img/UTREDF-1.38be2983.jpg";